import OrderFormOption from "@/entities/orderFormOption.entity.js";
import Order, { BuddhistNameCharacter } from "@/entities/order.entity.js";

const classes = {
  order: Order,
  buddhistNameCharacter: BuddhistNameCharacter,
  orderOption: OrderFormOption,
};

export default class EntityFactory {
  static create (name, args = {}) {
    return new classes[name](args);
  }
}
